import { Header, Root } from "./coming-soon.styles"

export const ComingSoon = () => (
	<Root>
		<Header>Coming Soon</Header> 
	</Root>
);